import React from "react";
import {Hero} from "./Hero"
import {HeroType1Block} from "./HeroType1Block"
import {HEROTYPE1} from "Consts/heroTypes"
import {Breadcrumbs as BreadcrumbsComp} from "../Breadcrumbs/Breadcrumbs";

export const HeroSwitcher = (model) => {
    const heroType = () => {
        switch (model?.Hero?.Alias) {
            case HEROTYPE1:
                return <HeroType1Block {...model?.Hero} breadcrumbLength={model?.Breadcrumbs?.length}/>
            default:
                return model?.ShowHero && (!!model?.ResponsiveImages?.length && !!model?.ResponsiveImages[0]?.Desktop?.length || !!model?.ResponsiveImage?.length && !!model?.ResponsiveImage?.Desktop?.length) ?
                    <Hero {...model} /> : <></>
        }
    }

    return <>
        {typeof(model?.Hero) !== 'undefined'&& <BreadcrumbsComp Items={model.Breadcrumbs}/>}
        {heroType()}
        {typeof(model?.Hero) === 'undefined' && <BreadcrumbsComp Items={model.Breadcrumbs}/>}
    </>
};
